var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2520,
    height: 1700,
    viewBox: "0 0 2520 1700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M1112.5 780V857.858V910.616V960.376V994.549H1119V1344.5V1399.82H1305.97H1334.15H1352.73H1527.79V1353.06V1343.47V994.549V959.177V780H1198.66H1112.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.59712
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M1526 781V857.858V858.458V909.417V911.215V959.177V960.376V994.549V1357.26V1378.24V1396.83L1705.25 1399.23H1733.42H1752.01H1945V1353.06V1343.47V994.549V959.177V781H1597.93H1526Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.59712
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M532 781.5H831.749H1057.17H1110.53V994.549H1117.72V1343.47V1398.63L957.049 1399.82H934.267H915.082H796.977H786.785H708.248H653.5H606H532V781.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.59712
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M1181.5 595.868V686H1147.69H958.246H883.905H865.92V780.52H532.586V976.563V1019.13V1397H473.833H352.73H346.735H312.562H293.5L293 1199V1151.5V1099V1070.69V1049.7V999.944V958.578V903.5V851V699.5V652V602.25V552.5V502V450V400V352V155.5H506H612H704.5H811.5H904.5H952.5H1004.5H1051.5H1147.69V574H1181.5V595.868Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.59712
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M1511.5 232.558V480.16V559.897V601.5H1692V686H1767V779.921H1946.26V1101.86V1397H2100.5H2153H2268.8H2362.5V995.148V959.177V952L2359.5 601.5V593.5V553.302V501.743V407.019V353.662V232.558V154.5H2203H2152.5H2102.5H2053H2005H1951.5H1902.5H1853H1851.5H1802.52H1801.5H1753.5H1752H1704.5H1701H1654H1604.5H1602.5H1504.5V232.558H1511.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.59712
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor3);
export default __webpack_public_path__ + "static/media/select-floor-3.09cede54.svg";
export { ForwardRef as ReactComponent };